import { Plus, X } from "lucide-react"
import { useState } from "react"
import { Button } from "@/shared/ui/button"
import { Input } from "@/shared/ui/input"

/** Список коротких строк: чаты для уведомлений, готовые ответы. */
export function StringListField({
	values,
	onChange,
	placeholder,
	max,
	itemLabel,
	inputMode,
}: {
	values: string[]
	onChange: (values: string[]) => void
	placeholder: string
	max: number
	itemLabel: string
	inputMode?: "text" | "numeric"
}) {
	const [draft, setDraft] = useState("")
	const add = () => {
		const value = draft.trim()
		if (!value || values.includes(value) || values.length >= max) return
		onChange([...values, value])
		setDraft("")
	}
	return (
		<div className="space-y-2">
			{values.length > 0 ? (
				<div className="flex flex-wrap gap-1">
					{values.map((value, index) => (
						<span
							key={value}
							className="flex items-center gap-1 rounded-md bg-muted px-2 py-0.5 text-sm"
						>
							{value}
							<Button
								type="button"
								variant="ghost"
								size="icon"
								aria-label={`Убрать ${itemLabel} ${value}`}
								className="h-4 w-4 hover:bg-transparent"
								onClick={() => onChange(values.filter((_, i) => i !== index))}
							>
								<X className="h-3 w-3" />
							</Button>
						</span>
					))}
				</div>
			) : null}
			{values.length < max ? (
				<div className="flex gap-2">
					<Input
						aria-label={`Новый ${itemLabel}`}
						placeholder={placeholder}
						inputMode={inputMode}
						value={draft}
						onChange={(event) => setDraft(event.target.value)}
						onKeyDown={(event) => {
							if (event.key === "Enter") {
								event.preventDefault()
								add()
							}
						}}
					/>
					<Button
						type="button"
						variant="outline"
						size="icon"
						aria-label={`Добавить ${itemLabel}`}
						disabled={!draft.trim()}
						onClick={add}
					>
						<Plus />
					</Button>
				</div>
			) : null}
		</div>
	)
}
